function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import logo from '../../assets/images/logo.png';
import emailImg from '../../assets/images/mail_sent.svg';
import { isUserAuthenticated } from "../../helpers/authUtils";

class Confirm extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "_isMounted", false);

    _defineProperty(this, "renderRedirectToRoot", () => {
      const isAuthTokenValid = isUserAuthenticated();

      if (isAuthTokenValid) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }
    });

    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  /**
   * Redirect to root
   */


  render() {
    const isAuthTokenValid = isUserAuthenticated();
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderRedirectToRoot(), (this._isMounted || !isAuthTokenValid) && /*#__PURE__*/React.createElement("div", {
      className: "account-pages mt-5 mb-5"
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
      className: "justify-content-center"
    }, /*#__PURE__*/React.createElement(Col, {
      lg: 5
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("div", {
      className: "card-header pt-4 pb-4 text-center bg-primary"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      src: logo,
      alt: "",
      height: "18"
    })))), /*#__PURE__*/React.createElement(CardBody, {
      className: "p-4 position-relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-center m-auto"
    }, /*#__PURE__*/React.createElement("img", {
      src: emailImg,
      alt: "",
      height: "64"
    }), /*#__PURE__*/React.createElement("h4", {
      className: "text-dark-50 text-center mt-4 font-weight-bold"
    }, "Please check your email"), /*#__PURE__*/React.createElement("p", {
      className: "text-muted mb-4"
    }, "A email has been send to ", /*#__PURE__*/React.createElement("b", null, "youremail@domain.com"), ". Please check for an email from company and click on the included link to reset your password."), /*#__PURE__*/React.createElement("p", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "btn btn-primary",
      to: "/account/login"
    }, "Back to Login"))))))))));
  }

}

export default connect()(Confirm);